import { registerPlugin } from '@capacitor/core';

export interface SaveDownloadPlugin {
  save(options: { filename: string; data: string; mimeType: string }): Promise<void>;
}

export const SaveDownload = registerPlugin<SaveDownloadPlugin>('SaveDownload');
